const {
  isPlainObject
} = require('lodash');
const {
  getFlattenedContentValues
} = require('@truqc/content-path');
const {
  evaluateSource
} = require('../lib/evaluateSource');

/**
  * @function evalute - evaluate getObjectValuesBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const object = await evaluateSource(source.object, content, parentContentPath, transientContext, nativeFunctions);
  if (!isPlainObject(object)) {
    return undefined;
  }
  const paths = await evaluateSource(source.paths, content, parentContentPath, transientContext, nativeFunctions);
  if (!Array.isArray(paths)) {
    return undefined;
  }
  const requireAllValues = await evaluateSource(source.requireAllValues, content, parentContentPath, transientContext, nativeFunctions);
  return getFlattenedContentValues(paths, object, requireAllValues);
};
module.exports = {
  evaluate
};